import axios from 'axios';
import { useEffect } from 'react';

import { ExplorerContextInterface } from '@page/explorer/interface/explorer-data.interface';

export const useLoadSchema = (setValue: (data: Partial<ExplorerContextInterface>) => void) => {
  useEffect(() => {
    const controller = new AbortController();
    let timeout: NodeJS.Timeout;
    const loadSchema = async () => {
      try {
        const response = await axios({
          url: `${import.meta.env.VITE_API_PORTAL_URL}/explorer`,
          method: 'GET',
        });

        setValue({
          ...response.data.data,
          data: new Map(response.data.data.data),
          isLoading: false,
          currentEnv: response.data.data.envs[0].type,
        });
      } catch (error) {
        console.error(error);
        timeout = setTimeout(loadSchema, 2000);
      }
    };

    loadSchema();

    return () => {
      controller.abort();
      clearTimeout(timeout);
    };
  }, []);
};
